import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
    CircleCheck,
    Clock,
    Mail,
    Plus
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import MessageTicket from "./components/MessageTicket";
import EmployeeInboxTabs from "./components/InboxTab";
import DepartmentGridCard from "./components/DepartmentCardGrid";
import {
    getTicketList 
} from "../../../../../redux/supportticket/supportticketState";
import { DEPARTMENT_INITIALS } from "variables/constants";

const EmployeeInbox = ({
    doSearch,
    pagination,
    recordList = []
}) => {
    const [selectedDepartment, setSelectedDepartment] = useState("All");

    const messages = (recordList || []).map(ticket => ({
        department: ticket.department,
        initial: DEPARTMENT_INITIALS[ticket.department] || "NA",
        title: ticket.tic_title,
        priority: ticket.ticket_status === "Open" ? "pending" : "resolved",
        status: ticket.ticket_priority?.toLowerCase(),
        time: ticket.created_time,
        date: ticket.created_date_at,
        messagePreview: ticket.tic_description?.substring(0, 80) + "...",
        fullMessage: ticket.tic_description,
    }));

    const total = messages.length;
    const pending = messages.filter(m => m.priority === "pending").length;
    const resolved = messages.filter(m => m.priority === "resolved").length;

    useEffect(() => {
        doSearch({
            paginate: pagination.per_page,
        });
    }, [doSearch, pagination.per_page]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"My Inbox"}
                    icon={Mail}
                    description={"Connect with Hyvid departments for support and assistance"}
                    color={"bg-emerald"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Contact Hyvid Department"
                            description="Send a message to any Hyvid department for support and assistance"
                            label="New Message" 
                            btnClass="ticket btn-ticket white" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <MessageTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Total Messages"
                            icon={<Mail />}
                            display={total}
                        />
                        <SummaryItem
                            title="Pending"
                            icon={<Clock />}
                            display={pending} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved}
                        />
                   </div>
                </SummaryHeader>
                <DepartmentGridCard 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                    onSelectDepartment={setSelectedDepartment}
                />
                <EmployeeInboxTabs 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeInbox);